module.exports = __webpack_public_path__ + "img/email.4abea1e8.svg";